export enum SessionKeyEnum {
  TENANT_ID = 'TENANT_ID',
  TENANT_URL = 'TENANT_URL',
  TENANT_LOGO = 'TENANT_LOGO',
  TENANT_NAME = 'TENANT_NAME',
  TENANT_DOMAIN = 'TENANT_DOMAIN',
  TENANT_ICON = 'TENANT_ICON',
}
